const ADDRESS_VALIDATION_STATUSES = {
  VERIFIED: 'verified',
  VERIFIED_CORRECTED: 'verified_corrected',
  MANUAL_OVERRIDE: 'manual_override',
  NOT_VALIDATED: 'not_validated',
} as const;

export default ADDRESS_VALIDATION_STATUSES;
